export default __webpack_public_path__ + "static/media/5_1.8132e4df.png";